import { render, staticRenderFns } from "./LeaveReviewDetails.vue?vue&type=template&id=6e42782b&scoped=true&"
import script from "./LeaveReviewDetails.vue?vue&type=script&lang=js&"
export * from "./LeaveReviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeaveReviewDetails.vue?vue&type=style&index=0&id=6e42782b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42782b",
  null
  
)

export default component.exports